export default "__VITE_ASSET__0TdLZ4w4__"